import { generateStars, generateRocks } from "./landscape";

(() => {
  generateStars(200)
  generateRocks(50)
})()